/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProject = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      id
      projectName
      name
      email
      sourceLanguage
      targetLanguages
      dueDate
      contentType
      serviceType
      urgencyLevel
      specialInstructions
      poNumber
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProjects = /* GraphQL */ `
  query ListProjects(
    $filter: ModelProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectName
        name
        email
        sourceLanguage
        targetLanguages
        dueDate
        contentType
        serviceType
        urgencyLevel
        specialInstructions
        poNumber
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSupportRequest = /* GraphQL */ `
  query GetSupportRequest($id: ID!) {
    getSupportRequest(id: $id) {
      id
      name
      email
      question
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSupportRequests = /* GraphQL */ `
  query ListSupportRequests(
    $filter: ModelSupportRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSupportRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        question
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
